import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Button } from '../../Button';
import { VscCloudDownload, VscMail } from 'react-icons/vsc';
import './../resume/Resume.css';

function Home() {
    return (
        <>
            <Helmet>
                <title>Kai Cheng | The official home of all things by Kai Cheng</title>
                <meta name='description' content='The official home of all things by Kai Cheng. Resume, recipes, blog posts, and more - all in one place!' />
                <link rel='canonical' href='https://www.kaicheng.ca/' />
            </Helmet>
            <h1>Welcome to the home of all things by Kai Cheng!</h1>
            <section className='resume__container mb-50'>
                <h2 className='resume__container__title mb-30'>About Me</h2>
                <div className='element'>
                    <div className='col-33'>
                        <img src='/images/kai.png' className='headshot' alt='Kai Cheng' loading='lazy' />
                    </div>
                    <div className='col-66'>
                        <div className='element-container'>
                            <h3 className='mb-20'>Hello,</h3>
                            <p className='mb-20'>
                                I am Kai Cheng, a senior software engineer from Ottawa, Ontario, Canada. I have a rich experience in e-commerce, web development, and cloud computing.
                                I am a collaborative, team-player that is able to lead.
                                I graduated from Carleton University with a Bachelor of Computer Science with a focus in Mobile Application Development and a minor in Business in 2014.
                                I am a very active person, I play soccer, basketball, volleyball, golf, and enjoy going running and skiing.
                                I love to explore and go on adventures and I've been fortunate to travel to many parts of the world.
                            </p>
                            <div className='element mb-20'>
                                <div className='row'>
                                    <div className='col-50'>
                                        <p className='mb-10 text-888'>Name: <span className='text-dark'>Kai Cheng</span></p>
                                        <p className='mb-0 text-888'>Website: <span className='text-dark'><Link to='/'>https://www.kaicheng.ca/</Link></span></p>
                                    </div>
                                    <div className='col-50 mt-10'>
                                        <p className='mb-10 text-888'>Location: <span className='text-dark'>Ottawa, ON, Canada</span></p>
                                        {/*<p className='mb-0 text-888'>Email: <span className='text-dark'>blah@blah.com</span></p>*/}
                                    </div>
                                </div>
                            </div>
                            <Link to='/uploads/kai-cheng-resume.pdf' className='mr-10' target='_blank'>
                                <Button buttonStyle='btn--small' buttonColor='red' >
                                    <VscCloudDownload className='btn-icon' />
                                    Download CV
                                </Button>
                            </Link>
                            <Link to='/contact'>
                                <Button buttonStyle='btn--small' buttonColor='blue'>
                                    <VscMail className='btn-icon' />
                                    Hire Me
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home;
